import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
import i18n from "./i18n";
import { extractUtmFromString, extractUtmFromObject } from "./methods";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: "/",
			alias: "/index.html",
			beforeEnter: (to, from, next) => {
				if (!["fr", "en", "es", "it"].includes(to.query.lang)) {
					to.query.lang = "fr";
				}

				const lang = to.query.lang || "fr";
				i18n.locale = lang;
				next();
			},
			component: () => import("./App.vue")
		},
		{
			path: "*",
			redirect: "/pages/error-404"
		}
	]
});

router.beforeEach(async (to, from, next) => {
	let utm = extractUtmFromString(document.cookie);

	if (!utm || (utm && Object.keys(utm).length === 0)) {
		utm = extractUtmFromObject(to.query);
	}

	let { plan_id, coupon_code, shopify_redirect, hmac, host, session, shop, timestamp } = to.query ?? {};

	console.log("{ hmac, host, session, shop, timestamp }", { hmac, host, session, shop, timestamp });

	store.commit("planId", plan_id);
	store.commit("couponCode", coupon_code);
	store.commit("utm", utm);
	store.commit("shopify", { hmac, host, session, shop, timestamp });
	store.commit("shopify_redirect", shopify_redirect ?? false);

	next();
});

router.afterEach(async () => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");

	if (appLoading) {
		appLoading.style.display = "none";
	}
});

export default router;
